import { render, staticRenderFns } from "./UserViewMore.vue?vue&type=template&id=2ff713f3"
import script from "./UserViewMore.vue?vue&type=script&lang=js"
export * from "./UserViewMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports